import { jsx as _jsx } from "react/jsx-runtime";
import { AddAdditionalRecipients } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/AddAdditionalRecipients/AddAdditionalRecipients';
export const renderAdditionalRecipientsModal = (param)=>{
    let { draft, setDraft, wasSubmitted, title, primaryContact } = param;
    return {
        title,
        testId: 'edit-additional-recipients-modal',
        onSubmit: (defaultBehavior)=>{
            defaultBehavior();
        },
        content: /*#__PURE__*/ _jsx(AddAdditionalRecipients, {
            initialState: draft.reviewers(),
            showReviewerErrors: wasSubmitted || undefined,
            primaryContact: primaryContact,
            onChange: (newReviewers)=>setDraft(draft.setReviewers(newReviewers))
        })
    };
};
